import { ReactNode } from 'react';
import { Header } from './Header';

interface AppLayoutProps {
  children: ReactNode;
}

/**
 * App Layout Component
 * Provides consistent layout structure with Header and main content area
 * 
 * Features:
 * - Fixed header at top
 * - Main content area with proper padding to account for fixed header
 * - Responsive padding (pt-14 on mobile, pt-16 on desktop)
 */
export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="h-screen w-screen flex flex-col overflow-hidden">
      <Header />
      {/* Mobile: pt-14 (3.5rem = 56px), Desktop: pt-16 (4rem = 64px) */}
      <main className="flex-1 flex overflow-hidden pt-14 sm:pt-16">
        {children}
      </main>
    </div>
  );
}

